import convertNumber from 'utils/common/convertNumber';
import convertFractionToPercent from 'utils/math/convertFractionToPercent';

interface IOption {
  fixed?: number;
  symbol?: string;
}

const DEFAULT_FEE_FIXED = 2;

const convertFrancFeeToPercent = (value: number, options?: IOption) => {
  const { fixed = DEFAULT_FEE_FIXED, symbol } = options || {};

  const percentValue = convertFractionToPercent(value || 0, { fixed, symbol: '' });
  const formattedValue = convertNumber(+percentValue || 0, fixed);

  return symbol ? `${formattedValue}${symbol}` : formattedValue;
};

export default convertFrancFeeToPercent;
